import { declareString } from "@1js/localization";

export const BookmarkButtonLabel = declareString(
  "promptLibrary.bookmarkButtonLabel",
  {
    text: "Saved prompts",
    comment:
      "Text that appears on a toggle-able button that allows users to filter Copilot prompts with the ones in their bookmarked list",
  }
);

export const YourPromptsLabel = declareString(
  "promptLibrary.yourPromptsLabel",
  {
    text: "Your prompts",
    comment:
      "Text that appears on a toggle-able button that allows users to filter Copilot prompts with the ones in their saved list",
  }
);
